<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">Crear Packing List de embarque</h1>
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer" no-body>
              <form-wizard
                color="#0074d9"
                errorColor="#ff4136"
                ref="wizard"
                shape="circle"
                stepSize="sm"
                nextButtonText="Siguiente"
                backButtonText="Atrás"
                finishButtonText="Finalizar"
                @on-complete="onComplete"
                title=""
                @on-change="renewInfo"
                subtitle=""
              >
                <tab-content title="Selección  embarque" :before-change="submitFormListaEmbarque">
                  <formListaEmbarque :data="data" ref="formListaEmbarque"></formListaEmbarque>
                </tab-content>

                <tab-content title="Seleccione Pallet del Embarque" :before-change="terminarYGuardar">
                  <formListaEmbarquePallet ref="formListaEmbarquePallet"></formListaEmbarquePallet>
                </tab-content>
              </form-wizard>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import formListaEmbarque from "./formListaEmbarque.vue";
import formListaEmbarquePallet from "./formListaEmbarquePallet.vue";

import { shuffleArray } from "@/shared/utils";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { bus } from "../../main";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

export default {
  name: "ListaEmbarque",
  components: {
    formListaEmbarque,
    formListaEmbarquePallet
  },
  mounted() {},
  data() {
    return {
      data: {
        boardinginstruction: ""
      }
    };
  },
  computed: {},
  methods: {
    loadBoarding(a) {},
    submitFormListaEmbarque() {
      var formValidacion = this.$refs.formListaEmbarque.saveForm();
      if (formValidacion == 0) {
        this.$swal.fire("Campos requeridos o invalidos en el formulario", "", "warning");
        return false;
      } else {
        bus.$emit("onChangeBording", this.data.boardinginstruction);
        return true;
      }
    },

    terminarYGuardar() {
      this.$swal
        .fire({
          title: "Seguro que quieres terminar?",
          text: "",
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonText: "SI"
        })
        .then((result) => {
          if (result.value) {
            var padre = this;

            var objPallets = this.$refs.formListaEmbarquePallet.getpalletscheck();
            var arrayPallets = [];

            if (Object.keys(objPallets).length > 0) {
              for (var i = 0; i < Object.keys(objPallets).length; i++) {
                arrayPallets[i] = objPallets[i].id;
              }

              const formData = {
                pallets: arrayPallets
              };

              padre.$axios
                .put("/api/comex/shipment/" + this.data.boardinginstruction + "/set_packing_list/", formData)
                .then((res) => {
                  padre.$swal.fire("Operación realizada con éxito", "", "success");

                  this.$router.push("/exportaciones/listado");

                  return true;
                })
                .catch((error) => {
                  padre.$swal.fire("Problemas al terminar proceso", "", "error");

                  return false;
                });
            } else {
              padre.$swal.fire("Por favor seleccione por lo menos un pallet", "", "info");
            }
          } else {
          }
        });
    },
    renewInfo: function (prevIndex, nextIndex) {},
    onComplete() {}
  },
  beforeMount() {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
